import ReactMarkdown, { type Components } from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import { CodeBlock } from '@/lib/ui-kit/components/ui/CodeBlock.component'
import { processTagsInParagraph } from '@/lib/utils/processTags'

import { TextLink } from './TextLink.component'
import { TextListItem } from './TextListItem.component'
import { TextStrikethrough } from './TextStrikethrough.component'
import { TextBold } from './TextStrong.component'
import { TextUnderline } from './TextUnderline.component'

interface ReactMarkdownProps {
  components?: Components
  children?: string | null
  className?: string
  parseCustomTags?: boolean
}

export const Markdown = ({
  children,
  components,
  // currently only set to true for the Academy Highlight
  parseCustomTags = false,
}: ReactMarkdownProps) => {
  const paragraphComponent = parseCustomTags
    ? processTagsInParagraph
    : undefined

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkBreaks, remarkGfm]}
      components={{
        strong: TextBold,
        u: TextUnderline,
        a: TextLink,
        del: TextStrikethrough,
        code: CodeBlock,
        li: TextListItem,
        ...(parseCustomTags ? { p: paragraphComponent } : {}),
        ...components,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
